<template>
  <v-app>    
    <v-content>
      <iframe name="frameResizeMyWebStor" width=100% height=100% style="position:absolute;z-index:-1"></iframe>
      <v-snackbar
        top
        color="error"
        v-model="snackBarShow"
      >
      {{textSnackbar}}
      </v-snackbar>      

      <stepperForm
        v-if="this.vidgetOptions!=undefined"
        :vidgetOptions="vidgetOptions"
        :formToken="formToken"
        :appOptions="appOptions"
        :utmObject="utmObject"
      />

      <v-row style="height:100%" align="center" justify="center" v-if="loading">
        <v-progress-circular
        :size="50"
        color="#030303"
        indeterminate
      ></v-progress-circular>
      </v-row>
      
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios';
export default {
  name: 'App',

  components: {
    stepperForm:()=>import("./components/stepperForm")
  },

  methods:{
    testJson:function(jsonString){
      try {
        JSON.parse(jsonString);
        return true;
      } catch (error) {
        return false;
      }
    },
    getParam:function(parametrName){
        var tempArr=document.location.href.match(new RegExp("("+parametrName+")=([^&]*)"));
        if (tempArr!=null&&tempArr.length!=undefined&&tempArr.length==3){
            return tempArr[2];
        }
        else{
            return "";
        }
    },
    sendNewHeight:function(){
      let tempObj={
        event:"updateHeightWidgetMyWebstor",
        height:window.getComputedStyle(document.body).height
      };
      window.parent.postMessage(JSON.stringify(tempObj), '*');      
    }
  },

  mounted:function(){
    if (window!=window.parent){
      frameResizeMyWebStor.onresize=()=>{
        this.sendNewHeight();
      };
      this.sendNewHeight();
    }
    this.$root.$on('showSnackBar', (obj)=>{
      this.snackBarShow=obj.show;
      this.textSnackbar=obj.text;
    });    
    var formToken=this.getParam('token');
    if (String(formToken).length>0){
      this.formToken=formToken;

      var utm_source=this.getParam("utm_source");
      var utm_medium=this.getParam("utm_medium");
      var utm_campaign=this.getParam("utm_campaign");
      var utm_content=this.getParam("utm_content");
      var utm_term=this.getParam("utm_term");

      if (utm_source!=""||utm_medium!=""||utm_campaign!=""||utm_content!=""||utm_term!=""){
        this.utmObject={
          utm_source:utm_source,
          utm_medium:utm_medium,
          utm_campaign:utm_campaign,
          utm_content:utm_content,
          utm_term:utm_term,
        };
      }

      axios.post('https://crm.mywebstor.com/local/webhooks/calendar/indexv4.php', {
          tokenForm: formToken,
          action:'getFormByToken'
      })
      .then((response)=>{
        if (response.data.status=="success"){
          if (this.testJson(response.data.data.configForm)){
            this.vidgetOptions=JSON.parse(response.data.data.configForm);
            if (this.vidgetOptions.yandexId||this.vidgetOptions.googleId){
              this.$root.$on('sendEventYandexGoogle', (eventName)=>{
                if (this.vidgetOptions.googleId){eventName
                  gtag('event', eventName);
                }
                if (this.vidgetOptions.yandexId){
                  ym(this.vidgetOptions.yandexId, 'reachGoal', eventName);
                }
              });
            }
            if (this.vidgetOptions.googleId){
              gtag('config', this.vidgetOptions.googleId);
              this.$root.$emit('sendEventYandexGoogle', "myWebStor_createWidget"); 
            }
            if (this.vidgetOptions.yandexId){
              ym(this.vidgetOptions.yandexId, "init", {});
              this.$root.$emit('sendEventYandexGoogle', "myWebStor_createWidget");               
            }            
            this.appOptions=response.data.data.appConfig;
            let lang = this.appOptions?.settings?.defaultLang;
            if(lang) {
              this.$i18n.locale = lang;
              this.$vuetify.lang.current = lang;
            }
            if(this.vidgetOptions.noSelectProduct
            && +this.vidgetOptions.widgetMinutes > 0)
              this.appOptions.settings.sizeGrid = +this.vidgetOptions.widgetMinutes;
          }else{
            this.textSnackbar=this.$t("errors.invalid_online_token");
            this.snackBarShow=true;
          }          
        }
        else{
          this.textSnackbar=response.data.message;
          this.snackBarShow=true;
        }
        this.loading=false;
      })
      .catch((error)=>{
        this.textSnackbar=error;
        this.snackBarShow=true;
        this.loading=false;
      });
    }
    else{
      this.textSnackbar=this.$t("errors.invalid_online_token");
      this.snackBarShow=true;
    }
  },

  data: () => ({
    vidgetOptions:undefined,
    appOptions:undefined,
    loading:true,
    snackBarShow:false,
    textSnackbar:"",
    formToken:"",
    utmObject:undefined,
  }),
};
</script>
